import type { UrlObject } from 'url'

import { requiresDocumentUrl } from './indexing-policy'

export const linkHrefString = (href: string | UrlObject): string => {
  if (typeof href === 'string') return href
  if (href.href) return href.href
  const host = href.hostname ?? href.host
  return `${host ? `${href.protocol ?? 'https:'}//${host}` : ''}${href.pathname ?? (href.search || (href.query ? '?' : href.hash) || '')}`
}

// Next Link can resolve relative hrefs against an internal rewritten route
// during SSR. Give it the public pathname explicitly, preserving URL-object
// query/hash fields, so the rendered href agrees with the relationship policy.
export const resolveLinkHref = (href: string | UrlObject, documentUrl?: string): string | UrlObject => {
  if (!documentUrl || !requiresDocumentUrl(linkHrefString(href))) return href
  const resolved = new URL(linkHrefString(href), new URL(documentUrl, 'https://www.hearingtracker.com/'))
  return typeof href === 'string'
    ? `${resolved.pathname}${resolved.search}${resolved.hash}`
    : { ...href, pathname: resolved.pathname }
}
